import { Table, Spin, Button } from "antd";
import { Link } from "react-router-dom";
import Header from "../../../components/HeaderList";
import { ReactComponent as Eye } from "../../../assets/icons/eye.svg";
import { getColumnSearchProps } from "../../../utils/tables";
import styles from "../styles/ClientsUI.module.css";

const ClientsUI = (props) => {
  const { loading, clients, exportData, page, handlePage } = props;

  const columns = [
    {
      title: "No",
      dataIndex: "correlativo",
      align: "center",
    },
    {
      title: "Nombre",
      dataIndex: "name",
      ...getColumnSearchProps("name"),
    },
    {
      title: "Apellido",
      dataIndex: "lastname",
      ...getColumnSearchProps("lastname"),
    },
    {
      title: "Teléfono",
      dataIndex: "phone",
      align: "center",
      ...getColumnSearchProps("phone"),
    },
    {
      title: "DUI",
      dataIndex: "identity",
      align: "center",
      ...getColumnSearchProps("identity"),
    },
    {
      title: "Correo",
      dataIndex: "email",
      align: "center",
      ...getColumnSearchProps("email"),
    },
    {
      title: "Estado",
      dataIndex: "Status",
      align: "center",
      filters: [
        { value: 1, text: "Activo" },
        { value: 0, text: "Bloqueado" },
      ],
      filterMultiple: false,
      onFilter: (val, record) => !!record.Status === !!val,
      render: (val) => (val ? "Activo" : "Bloqueado"),
    },
    {
      title: "Ver",
      align: "center",
      dataIndex: "id",
      render: (id) => (
        <Link to={`/ajustes/clientes/${id}`} className={styles.watch}>
          <Eye className={styles.eye} />
        </Link>
      ),
    },
  ];

  return (
    <div className={styles.view}>
      <Header
        back="/ajustes"
        title="Clientes"
        actions={
          <Button size="large" type="primary" onClick={exportData}>
            Exportar
          </Button>
        }
      />
      {loading ? (
        <div className={styles.loader}>
          <Spin size="large" />
        </div>
      ) : (
        <div style={{ overflowX: "auto", width: "100%" }}>
          <Table
            columns={columns}
            dataSource={clients}
            rowKey="id"
            pagination={{
              defaultCurrent: page,
              onChange: handlePage,
            }}
          />
        </div>
      )}
    </div>
  );
};

export default ClientsUI;
